export const SITE_URL = "https://grandkansasnorth.com";
export const SITE_NAME = "Grand & Kansas North";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/es/images/optimized/hero-grand-kansas-north-01-1280.webp`;

export type PageMetaConfig = {
  title: string;
  description: string;
  /** Hash route path, e.g. `/about` */
  path: string;
};

const DEFAULT_DESCRIPTION =
  "Grand & Kansas North is a proposed 276-home community plan at Grand Avenue and Kansas Street in El Segundo's Smoky Hollow neighborhood, with 18 income-restricted homes, on-site parking, and landscaped ground-floor open space.";

export const PAGE_META: Record<string, PageMetaConfig> = {
  "/": {
    title: "Grand & Kansas North | El Segundo Community Housing",
    description: DEFAULT_DESCRIPTION,
    path: "/",
  },
  "/about": {
    title: "About the Project | Grand & Kansas North",
    description:
      "Learn how Grand & Kansas North evolved through neighbor listening sessions in Smoky Hollow — 276 homes, landscaped ground-floor open space at Holly & Kansas, 18 income-restricted homes, and homes reserved for LAAFB families.",
    path: "/about",
  },
  "/updates": {
    title: "Project Updates | Grand & Kansas North",
    description:
      "Follow the latest Grand & Kansas North milestones, community sessions, and design refinements in El Segundo's Smoky Hollow neighborhood.",
    path: "/updates",
  },
  "/feedback": {
    title: "Community Feedback | Grand & Kansas North",
    description:
      "Share feedback and read what neighbors are saying about Grand & Kansas North — community input that shaped the Smoky Hollow plan.",
    path: "/feedback",
  },
  "/faqs": {
    title: "Frequently Asked Questions | Grand & Kansas North",
    description:
      "Answers to common questions about Grand & Kansas North — homes, parking, landscaped ground-floor open space at Holly & Kansas, military housing, and the community process in El Segundo.",
    path: "/faqs",
  },
  "/support": {
    title: "Support the Project | Grand & Kansas North",
    description:
      "Add your voice to Grand & Kansas North. Show El Segundo neighbors support this Smoky Hollow community plan through the home page support form.",
    path: "/support",
  },
  "/admin/login": {
    title: "Team Login | Grand & Kansas North",
    description: "Sign in to the Grand & Kansas North project team dashboard.",
    path: "/admin/login",
  },
};

export function canonicalUrlForPath(path: string): string {
  if (path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}/#${path}`;
}

export function metaForPath(path: string): PageMetaConfig {
  return PAGE_META[path] ?? PAGE_META["/"];
}
